export default "__VITE_PUBLIC_ASSET__c1d8e613__"